import {
  Timeline,
  TimelineItem,
  TimelineDot,
  TimelineConnector,
  TimelineSeparator,
  TimelineContent,
  timelineItemClasses,
} from "@mui/lab";

import styles from "./timeline.module.scss";
import { Avatar } from "@mui/material";
import moment from "moment";

const Timelines = ({ historyData }: { historyData: any }) => {
  console.log(historyData);
  return (
    <Timeline
      position="right"
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {historyData?.data?.Items?.map((h: any) => {
        if (h.Comment) {
          return (
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot>
                  <Avatar className={styles.avatar}>AA</Avatar>
                </TimelineDot>
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className={styles.box}>
                  <div className={styles.name}>Julia czerwińska</div>
                  <div className={styles.description}>
                    Julia czerwińska 123213213131
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
          );
        }

        return (
          <TimelineItem>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <span>{h.MakingChangeUserLabel}</span>
              <span>{h.Text}</span>
              <span>{moment(h.Date).format("DD.MM.YYYY | HH:mm")}</span>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default Timelines;
